import { render, staticRenderFns } from "./DesktopFooter.vue?vue&type=template&id=44b97cac&scoped=true&"
import script from "./DesktopFooter.vue?vue&type=script&lang=js&"
export * from "./DesktopFooter.vue?vue&type=script&lang=js&"
import style0 from "./DesktopFooter.vue?vue&type=style&index=0&id=44b97cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b97cac",
  null
  
)

export default component.exports